import { useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { $journalApi } from "@/entities/journal/fetch/fetch-client";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";

export const useRejectSignEntry = (sectionOneId: string, search?: string) => {
  const queryClient = useQueryClient();

  // /api/v1/journals/section-one/{sectionOneListId}/items/{itemNoVersionId}/status/signerRejected
  
  return $journalApi.useMutation(
    "post",
    "/api/v1/journals/section-one/{sectionOneListId}/items/{itemNoVersionId}/status/signerRejected",
    {
      onSuccess: (_, variables) => {
        const { sectionOneListId } = variables.params.path;
        queryClient.invalidateQueries(
          journalsQueries.getSection1({ sectionOneId: sectionOneListId }),
        );
        notification.success({
          message: NOTIFICATION_MESSAGES.ENTRY_RECALLED_SUCCESS, // "Запись отозвана"
        });
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({
            sectionOneId,
            search,
          }).queryKey,
        });
        queryClient.invalidateQueries({
          queryKey:
            journalsQueries.getSectionOneSignersList(sectionOneId).queryKey,
        });
      },
      onError: () => {
        notification.error({
          message: NOTIFICATION_MESSAGES.ENTRY_REJECT_NOT_POSSIBLE, // "Не удалось отклонить запись"
        });
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({
            sectionOneId,
            search,
          }).queryKey,
        });
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({
            sectionOneId,
            search,
          }).queryKey,
        });
      },
    },
  );
};
